"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interrupt = void 0;
/**
 * Provide the ability to wait until an interrupt next fires.
 *
 * Wait for the next interrupt
 * ```
 * const interrupt = new Interrupt();
 * setTimeout(() => interrupt.fire(), 1000);
 * await interrupt.promise;
 * console.log('Interrupt has fired');
 * await interrupt.promise; // will never pass this point
 * ```
 *
 * Ensure you save the interrupt you want to catch before allowing it
 *  to be called
 * ```
 * const interrupt = new Interrupt();
 * const taskDone = interrupt.promise; // save the interrupt
 * doTask(() => interrupt.fire()); // this might take a while, or might complete immediately
 * await taskDone;
 * ```
 */
class Interrupt {
    constructor() {
        this.pass = (_v) => { };
        this.promise = this.buildPromise();
        this.fire = this.fire.bind(this);
    }
    /**
     * Trigger the next interrupt
     *
     * force bound to this object, can be used in a callback directly
     */
    fire(v) {
        const pass = this.pass;
        this.promise = this.buildPromise();
        pass(v);
    }
    buildPromise() {
        return new Promise((p) => (this.pass = (v) => p(v)));
    }
}
exports.Interrupt = Interrupt;
//# sourceMappingURL=Interrupt.js.map